export interface AssignmentFieldOption {
  label: string;
  value: string; // e.g., 'assignee.Email'
  icon?: string;
}

/**
 * Assignment field options for Recipients (2 options - Email only)
 * Used in SlackRecipientsSelect
 */
export const ASSIGNMENT_RECIPIENT_OPTIONS: AssignmentFieldOption[] = [
  {
    label: 'Assignee',
    value: 'assignee.Email',
    icon: 'User',
  },
  {
    label: 'Next in Line',
    value: 'upNext.Email',
    icon: 'Devops',
  },
];

/**
 * Assignment field options for Message (5 options)
 * Used in SlackNewMessageEditor
 */
export const ASSIGNMENT_MESSAGE_OPTIONS: AssignmentFieldOption[] = [
  {
    label: 'Assignee',
    value: 'assignee.Name',
  },
  {
    label: 'Assignee First Name',
    value: 'assignee.FirstName',
  },
  {
    label: 'Next in Line',
    value: 'upNext.Name',
  },
  {
    label: 'Next in line First Name',
    value: 'upNext.FirstName',
  },
  {
    label: 'Assignment Group Name',
    value: 'assignmentGroup.Name',
  },
];

export const getAssignmentFieldLabel = (value: string): string => {
  const allOptions = [...ASSIGNMENT_RECIPIENT_OPTIONS, ...ASSIGNMENT_MESSAGE_OPTIONS];
  return allOptions.find((opt) => opt.value === value)?.label ?? value;
};

export const getAssignmentFieldIcon = (value: string): string | undefined => {
  return ASSIGNMENT_RECIPIENT_OPTIONS.find((opt) => opt.value === value)?.icon;
};

export const createAssignmentRecipientItem = (
  option: AssignmentFieldOption,
): SlackRecipientStruct => {
  return {
    type: 'Assignment',
    value: option.value,
    _label: option.label,
  };
};
